(function () {
  'use strict';

  var productCache = {};
  var runTimer = null;
  var observerStarted = false;

  function addStyles() {
    if (document.getElementById('ovc-variant-image-swatch-styles')) return;

    var style = document.createElement('style');
    style.id = 'ovc-variant-image-swatch-styles';
    style.textContent = [
      '.f8pr-variant-selection .icon-circle.ovc-image-swatch {',
      '  background-size: cover !important;',
      '  background-position: center !important;',
      '  background-repeat: no-repeat !important;',
      '  background-color: transparent !important;',
      '}',
      '.f8pr-variant-selection .icon-circle.ovc-text-swatch {',
      '  position: relative !important;',
      '  display: inline-flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  background-image: none !important;',
      '  background-color: #fff !important;',
      '  color: #111 !important;',
      '}',
      '.f8pr-variant-selection .icon-circle.ovc-text-swatch::after {',
      '  content: attr(data-ovc-swatch-label);',
      '  position: absolute;',
      '  inset: 0;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  padding: 2px;',
      '  font-family: inherit;',
      '  font-size: 9px;',
      '  font-style: normal;',
      '  font-weight: 600;',
      '  line-height: 1;',
      '  text-align: center;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function normaliseImage(image) {
    if (!image) return '';

    var src = '';
    if (typeof image === 'string') {
      src = image;
    } else {
      src = image.src || image.url || '';
      if (!src && image.image) {
        src = image.image.src || image.image.url || '';
      }
    }

    if (!src) return '';
    if (src.indexOf('//') === 0) return window.location.protocol + src;
    return src;
  }

  function productJsonUrl(productUrl) {
    var clean = String(productUrl || '').split('?')[0].replace(/\/$/, '');
    if (!clean) return '';
    return /\.js$/i.test(clean) ? clean : clean + '.js';
  }

  function getProduct(productUrl) {
    var url = productJsonUrl(productUrl);
    if (!url) return Promise.reject(new Error('Missing product URL'));
    if (productCache[url]) return productCache[url];

    productCache[url] = fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product request failed: ' + response.status);
      return response.json();
    });

    return productCache[url];
  }

  function optionName(option) {
    if (typeof option === 'string') return option;
    return option && option.name ? option.name : '';
  }

  function findColourIndex(product) {
    var options = product && Array.isArray(product.options) ? product.options : [];
    for (var index = 0; index < options.length; index += 1) {
      if (/colou?r/i.test(optionName(options[index]))) return index;
    }
    return -1;
  }

  function variantOptionValue(variant, index) {
    if (variant && Array.isArray(variant.options)) {
      var value = variant.options[index];
      if (value && typeof value === 'object') return value.value || value.name || '';
      return value || '';
    }
    return variant ? variant['option' + (index + 1)] || '' : '';
  }

  function variantImage(variant) {
    return normaliseImage(
      variant && (variant.featured_image || variant.featured_media || variant.image)
    );
  }

  function makeImageMap(product, colourIndex) {
    var map = {};
    var variants = product && Array.isArray(product.variants) ? product.variants : [];

    variants.forEach(function (variant) {
      var value = String(variantOptionValue(variant, colourIndex));
      var src = variantImage(variant);
      if (value && src && !map[value]) map[value] = src;
    });

    return map;
  }

  function colourTokenIsValid(value) {
    var token = String(value || '').trim().split(/\s+/).pop();
    if (!token) return false;

    var tester = document.createElement('span').style;
    tester.color = '';
    tester.color = token;
    return tester.color !== '';
  }

  function labelForInput(input) {
    if (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
      return input.nextElementSibling;
    }

    try {
      return document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    } catch (error) {
      return null;
    }
  }

  function safeCssUrl(src) {
    return 'url("' + String(src).replace(/\\/g, '%5C').replace(/"/g, '%22') + '")';
  }

  function shortLabel(value) {
    var text = String(value || '').trim();
    if (text.length <= 6) return text;
    return text.slice(0, 5);
  }

  function applySwatches(container, product) {
    var colourIndex = findColourIndex(product);
    if (colourIndex < 0) return;

    var options = product.options || [];
    var colourName = optionName(options[colourIndex]).toLowerCase();
    var images = makeImageMap(product, colourIndex);
    var inputs = container.querySelectorAll(
      '.f8pr-variant-selection input[type="radio"][name*="options["]'
    );

    Array.prototype.forEach.call(inputs, function (input) {
      var inputName = String(input.name || '').toLowerCase();
      if (inputName.indexOf(colourName) === -1 && !/colou?r/i.test(inputName)) return;

      var label = labelForInput(input);
      if (!label) return;

      var circle = label.querySelector('.icon-circle');
      if (!circle) return;

      var src = images[String(input.value)];
      if (src) {
        circle.style.setProperty('background-image', safeCssUrl(src), 'important');
        circle.style.setProperty('background-color', 'transparent', 'important');
        circle.style.setProperty('background-size', 'cover', 'important');
        circle.style.setProperty('background-position', 'center', 'important');
        circle.classList.add('ovc-image-swatch');
        circle.classList.remove('ovc-text-swatch');
        circle.removeAttribute('data-ovc-swatch-label');
        return;
      }

      var currentImage = window.getComputedStyle(circle).backgroundImage;
      if (currentImage === 'none' && !colourTokenIsValid(input.value)) {
        circle.classList.remove('ovc-image-swatch');
        circle.classList.add('ovc-text-swatch');
        circle.setAttribute('data-ovc-swatch-label', shortLabel(input.value));
      }
    });
  }

  function processContainer(container) {
    var productUrl = container.getAttribute('data-product-url');
    if (!productUrl && window.general) productUrl = window.general.viewed_product;
    if (!productUrl) return;

    getProduct(productUrl)
      .then(function (product) {
        applySwatches(container, product);
      })
      .catch(function () {
        // Leave the theme's native swatches unchanged if product JSON cannot be loaded.
      });
  }

  function run() {
    addStyles();
    var containers = document.querySelectorAll(
      '.m6pr[data-product-url], .m6pr-compact[data-product-url]'
    );
    Array.prototype.forEach.call(containers, processContainer);
  }

  function scheduleRun() {
    window.clearTimeout(runTimer);
    runTimer = window.setTimeout(run, 80);
  }

  function startObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('.f8pr-variant-selection')) ||
            (node.querySelector && node.querySelector('.f8pr-variant-selection'))
          );
        });
      });
      if (shouldRun) scheduleRun();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      startObserver();
    });
  } else {
    run();
    startObserver();
  }

  window.addEventListener('themeVariantUpdated', scheduleRun);
  document.addEventListener('shopify:section:load', scheduleRun);
})();
